import { useState } from 'react';
import { faqItems } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqItems[0]?.id ?? null);

  return (
    <section id="faq" className="w-full border-b border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-4">
            <SectionHeading
              index="06"
              label="FAQ"
              title="常见问题解答"
              desc="整理了关于入口更换、备用线路与镜像节点最常见的疑问，看完基本就能独立解决打不开的情况。"
              align="left"
            />
            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5">
              <p className="text-sm font-label font-medium text-foreground-950">还有别的问题？</p>
              <p className="mt-2 text-sm leading-6 text-foreground-600">
                如果上面的内容没能解决你的问题，可以在下方反馈入口失效情况，我们会尽快安排巡检。
              </p>
              <a
                href="#faq"
                className="mt-4 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                反馈失效入口
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
                </span>
              </a>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {faqItems.map((item) => {
                const open = openId === item.id;
                return (
                  <div key={item.id} className="border-b border-background-200/70 last:border-b-0">
                    <button
                      type="button"
                      onClick={() => setOpenId(open ? null : item.id)}
                      aria-expanded={open}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100/70"
                    >
                      <span className="text-sm font-label font-medium text-foreground-950 md:text-base">
                        {item.q}
                      </span>
                      <span
                        className={
                          open
                            ? 'flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50'
                            : 'flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-background-200 text-foreground-600'
                        }
                      >
                        <i className={open ? 'ri-subtract-line text-base' : 'ri-add-line text-base'} aria-hidden="true"></i>
                      </span>
                    </button>
                    {open && (
                      <div className="px-5 pb-5">
                        <p className="max-w-3xl border-l-2 border-primary-200 pl-4 text-sm leading-7 text-foreground-600">
                          {item.a}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}